export default () => ({
  op: 'add',
  path: '/flowConfig',
  value: {},
});
